import {RoomUserBehavior} from "@/core/api/room.user.behavior.api";
import {Room} from "@/core/api/room.api";
import {RoomUser} from "@/core/api/room.user.api";
import {RoomFile} from '@/core/api/room.file.api'
import { userApi } from '@/core/api/user.api'


export default {
  async loadSpeakDataMap({ dispatch, commit, getters, rootGetters }) {
    let userSpeakData = await RoomUserBehavior.getSpeakDataMap();
    commit('setUserSpeakData', {userSpeakData});
    return userSpeakData;
  },

  async toggleUserDeviceStatus({ dispatch, commit, getters, rootGetters }, {deviceType, roomUser}) {
    if(!roomUser) {
      roomUser = getters.me
    }

    if (!getters.isMe(roomUser) && !getters.hasEmceeRole()) {
      return
    }

    let deviceStatus = roomUser[`${deviceType}Status`]
    switch (deviceType) {
      case 'camera':
      case 'mic':
      case 'speaker':
        if(!roomUser.roomUserRole[deviceType]) {
          return
        }
        deviceStatus === 'on' ? deviceStatus = 'off' : deviceStatus='on'
        if(deviceType == 'speaker'){
          commit('room/CHANGE_ROOM_USER_DEVICE_STATUS', {userId:  roomUser.userId, deviceType, deviceStatus}, {root: true})
        }
        await Room.User.changeUserDeviceStatus(roomUser, deviceType, deviceStatus)
        Room.Record.setUserDevices({
          [`${deviceType}Status`]: deviceStatus,
        });
        break
      case 'screen': {
        if (roomUser.userId == getters.getScreenShareUser?.userId)
          return
        
        await Room.User.changeUserRole(roomUser, deviceType, !roomUser.roomUserRole[deviceType]);
        break
      }
      case 'draw':
        await Room.User.changeUserRole(roomUser, deviceType, !roomUser.roomUserRole[deviceType]);
        break
    }
  },

  async onPermissionChange({ dispatch, commit, getters, rootGetters }, {deviceType, roomUser}) {
    if(!roomUser) {
      roomUser = getters.me
    }

    if (!getters.isMe(roomUser) && !getters.hasEmceeRole()) {
      return
    }
    if (roomUser.roomUserRole.roleId === 'rtsp') {
      return
    }

    const deviceStatus = roomUser[`${deviceType}Status`]
    const hasRole = roomUser.roomUserRole[deviceType]

    const isWebinarLive = rootGetters['call/isWebinarLive'];

    switch (deviceType) {
      case 'camera':
      case 'mic':
        if(isWebinarLive && !getters.hasSpeakerRole(roomUser)){
          return
        }
        if (hasRole) {
          if(deviceStatus === 'on') {
            await Room.User.changeUserDeviceStatus(roomUser, deviceType, 'off')
            Room.Record.setUserDevices({
              [`${deviceType}Status`]: 'off',
            });
          } else {
            await Room.User.changeUserRole(roomUser, deviceType, false);
          }
        } else {
          await Room.User.changeUserRole(roomUser, deviceType, true);
          await Room.User.changeUserDeviceStatus(roomUser, deviceType, 'on')
          Room.Record.setUserDevices({
            [`${deviceType}Status`]: 'on',
          });
        }
        break
      case 'screen': {
        if(isWebinarLive && !getters.hasSpeakerRole(roomUser)){
          return
        }
        if (roomUser.userId == getters.getScreenShareUser?.userId)
          return
        
        await Room.User.changeUserRole(roomUser, deviceType, !roomUser.roomUserRole[deviceType]);
        break
      }
      case 'draw':
        await Room.User.changeUserRole(roomUser, deviceType, !roomUser.roomUserRole[deviceType]);
        break
    }
  },

  async kickRoomUser({ dispatch, commit, getters, rootGetters }, data) {
    if (data.self == undefined) {
      data.self = false;
    }

    if (!data.userId || !getters.hasEmceeRole()) {
      return;
    }

    await Room.User.kickRoomUser(data);
  },

  async kickAllRoomUser({ dispatch, commit, getters, rootGetters }) {
    if (!getters.hasEmceeRole()) {
      return;
    }

    await Room.User.kickAllRoomUser();
  },

  changeRoomUserNickname({ dispatch, commit, getters, rootGetters }, { roomUser, nickname }) {
    return Room.User.changeRoomUserNickname(roomUser, nickname)
  },

  async getUserProfileUrl({ dispatch, commit, getters, rootGetters }, roomUser) {
    let url = await Room.User.getUserProfileUrl(roomUser);
    return url || require('@/assets/roomType/lms/img/v-img/noimg-user.svg')
  },

  async sortUserList({ dispatch, commit, getters, rootGetters }, sortType) {
    if(sortType == 'lowOrder' || sortType == 'highOrder') {
      await dispatch('loadSpeakDataMap')
    }

    commit('room/SORT_ROOM_USER_LIST', sortType, { root: true })
  },

  async getUserPhone({ dispatch, commit, getters, rootGetters }, userId) {
    return await Room.User.getUserPhone(userId)
  },

  async getRoomUserRollBook({ dispatch, commit, getters, rootGetters }) {
    return await Room.User.getRoomUserRollBook();
  },

  async updateAttendanceList({ dispatch, commit, getters, rootGetters }) {
    let list = await Room.User.getRoomUserAttendanceList();
    commit('UPDATE_ATTENDANCE_LIST', list)
  },

  async getUserInfo({ dispatch, commit, getters, rootGetters }, userId) {
    return await Room.User.getUserInfo(userId);
  },

  async getMyNickname({ dispatch, commit, getters, rootGetters }, roomId) {
    return await Room.User.getMyNickname(roomId);
  },

  async changeRoomUserRoleId({ dispatch, commit, getters, rootGetters }, data) {
    if (!data.userId || !getters.hasEmceeRole()) {
      return;
    }
    await Room.User.changeRoomUserRoleId(data);
  },

  async requestSpeak({ dispatch, commit, getters, rootGetters }) {
    return await RoomUser.requestSpeak();
  },

  async cancelRequestSpeak({ dispatch, commit, getters, rootGetters }, reqSpeakId) {
    return await RoomUser.cancelRequestSpeak(reqSpeakId);
  },

  async confirmRequestSpeak({ dispatch, commit, getters, rootGetters }, {reqSpeakId, userId, reject}) {
    let roomUser = getters.getRoomUser(userId);
    if(!roomUser) return;

    reject = reject !== false;
    ['camera', 'mic'].forEach(func => {
      if(!roomUser.roomUserRole[func]) {
        RoomUser.changeUserRole(userId, func, !reject)
      }
    })
    return await RoomUser.confirmRequestSpeak({reqSpeakId, userId, reject});
  },
  async changeUserVideoQuality({ dispatch, commit, getters, rootGetters }, params){
    commit('SET_USER_VIDEO_QUALITY', params.userVideoQuality)
    return RoomUser.changeUserVideoQuality(params);
  },

  async uploadProfileImageFile({ dispatch, commit, getters, rootGetters }, file) {
    const res = await userApi.getUploadProfileImageSasUrl()
    const { filePath, url } = res.data;
    if (!url) {
      throw new Error('Could not get presigned URL');
    }

    const cancel = new AbortController()
    let removed = false
    try {
      await RoomFile.uploadToPresignedUrl({
        url, file,
        onUploadProgress: e => {
          if (removed) {
            return
          }
        },
        signal: cancel.signal
      })
      return filePath
    } catch (error) {
      cancel.abort()
      console.error('Error uploading file:', error)
      throw error
    }
  },

  async changeProfileImage({ dispatch, commit, getters, rootGetters }, data){
    return await userApi.changeProfileImage(data)
  },

  async getSpeakerUser({ dispatch, commit, getters, rootGetters }) {
    return (await Room.User.getSpeakerUser()).data
  }
}
